(function() {
  var btn = document.querySelector('.cc-support-buy-now');
  if (!btn) return;
  var variantId = btn.dataset.variantId;
  var sellingPlanId = btn.dataset.sellingPlanId;
  if (!variantId) return;

  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.style.pointerEvents = 'none';

    var purchaseType = document.querySelector('input[name="cc-support-purchase"]:checked');
    var item = { id: parseInt(variantId, 10), quantity: 1 };
    if (purchaseType && purchaseType.value === 'subscribe' && sellingPlanId) {
      item.selling_plan = parseInt(sellingPlanId, 10);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function(r) { return r.ok ? r.json() : r.json().then(function(err) { throw err; }); })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function(err) {
        console.error('Add to cart failed', err);
        btn.textContent = original;
        btn.style.pointerEvents = '';
        alert("Couldn't add this to your cart. Please try again or call (605) 622-0676.");
      });
  });
})();
